//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import filters from '../../filters/index';
import * as utils from '../../utils/index';
import * as CONSTANTS from '../../constants/index';
import KeyBoard from '../../components/KeyBoard';
import memberModule from '@/common/memberModule';
// import { Loading } from 'vant';
import { List } from "vant";

export default {
  name: 'policyList',
  data(){
    return{
      loading: false,
      finished: false,
      refreshing: false,
      currentPage:1,
      pageSize:20,
      totalPage:1,
      noMore:true,
      idcartNo:'',
      name:'',
      list:[],
      IsEmpty:false,
    }
  },
  created(){
    this.getUserInfo()
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener('scroll',this.scrollToActiveTap,true)
    })
  },
  components: {
    [List.name]: List,
  },
  computed:{
    ...mapGetters(['getLicenseKB']),
    ...mapState({
    }),
  },
  watch:{
    
  },
  methods:{
    ...mapMutations({
      openKB:'openKB',
      hideKB:'hideKB',
      setLicenseKB:'setLicenseKB',
    }),
    maskName(item){
      return utils.mask(item,'name')
    },
    dealDate(date) {
      var t = new Date(date.replace(/-/g, "/"));
      return t.format('yyyy.MM.dd');
      // return date.split(' ')[0];
    },
    dealSum() {
      var sum = 0;
      for (var i = 0; i < arguments.length; i++) {
          sum += Number(arguments[i]);
      }
      return this.formatPremium(sum);
    },
    formatPremium(premium, format, autoNumber) {
			/*
			 在JS中四舍五入的函数 toFixed(n) , n为要保留的小数位数。 n为0~20，当n超过20的时候，JS会出错。
			 如果小数点前和要截取的前一位都是0时，不会按常理截取。
			 var h=0.07
			 h.toFixed(1)的值为0.0
			 其实要解决这个问题，原来是不一定要重写js中的Number类型的toFixed方法的。
			 一个非常牛的同事，想到了一个他说很笨，但是我觉得很牛的方法。
			 JS的API上说， 截取的位数前至少要有一位不是0的。
			 于是，他这个很笨却很牛的方法是：使用toFixed方法之前加1，使用之后再减去1。
			 site://blog.csdn.net/znn626/article/details/7961731
			 */
        var newPre = premium;
        newPre = (new Number(premium)).toFixed(format || (format == 0 ? 0 : 2));
        return autoNumber ? Number(newPre) : newPre;
    },
    getUserInfo(){
      memberModule.checkLogin((res) => {
      // 如果用户没有实名认证，则前往认证页
        if (res.verifyFlag !== '1') {
	        location.href=`/eb-web/vue/member/authentication.html#/?back_url=${encodeURIComponent(location.href)}`
	        return
        }
	    // 列表接口的用户信息就从res里面取
        this.$set(this,'idcartNo',res.idcartNo);
        this.$set(this,'name',res.userName);
        this.getPolicyInfoCar(res.idcartNo,res.userName);
        // // 郭冲,340303198503261211
        // this.getPolicyInfoCar('340303198503261211','郭冲');
      }, memberModule.toLogin)
    },
    getPolicyInfoCar(idcartNo,userName,isAuto) {
      let data = {
        currentPage: this.currentPage,
        identifynumber: idcartNo,
        name: userName,
        pageSize: this.pageSize,
      };
      // this.refreshing = true;
      $http.policyInfoCar({data}).then((res)=>{
        if (res.errCode === 0) {
          let list = res.data.returnList;
          let list_copy = [];
          list.forEach((item,index)=>{
            if(item.licenseNo ==='*-*' || item.licenseNo ==='' ){
              // 列表只展示新车
              list_copy.push(item);
            }
          })
          this.$set(this,'list',list_copy);
          if(!list_copy.length){
            this.$set(this,'IsEmpty',true);
          }
          // let returnCount = res.data.returnCount;
          // // 总页数
          // let totalPage = Math.ceil(returnCount/this.pageSize);
          // this.$set(this,'totalPage',totalPage);
          // if(list.length){
          //   if(!isAuto){
          //     this.$set(this,'list',list);
          //   }else{
          //     list.push(res.data.returnList);
          //     this.$set(this,'list',list);
          //   }
          //   this.$set(this,'currentPage',res.returnPage++);
          // }
        } else {
          Toast(res.errMsg || res.returnMsg || texts.fail);
          this.$set(this,'IsEmpty',true);
        }

      }).catch(()=>{
        this.$set(this,'IsEmpty',true);
      });
    },
    // //滚动加载时触发
    // onLoad() {
    //   this.loading = true;
    //   if(this.currentPage > this.totalPage) {
    //     this.loading = false;
    //   }
    //   this.getPolicyInfoCar(this.idcartNo,this.name,true);
    // },
    onRefresh() {
      this.refreshing = false;
      this.currentPage = 1 ;
      this.totalPage = 1 ;
      this.$set(this,'currentPage',1);
      this.getPolicyInfoCar(this.idcartNo,this.name);
    },
    tolicenseModify(item){
      this.$router.push({path:'/license_modification',query:{
        policyNo:item.policyNo||'',
        frameNo:item.frameNo||'',
        insuredName:item.insuredName||'',
        phone:item.phone||'',
        identifyNumber:item.identifyNumber || '',
        licenseNo:item.licenseNo || '',
        mergePolicyNo:item.mergePolicyNo || '',
        startDate:item.startDate||'',
        mergeStartDate:item.mergeStartDate||'',
        productCode:item.productCode || '',
        mergeProductCode:item.mergeProductCode || '',
      }});
    },
    toDetail(item){
      let policyNo = '';
      let mergePolicyNo = '';
      let jqNo = '';
      let syNo = '';
      if(item.productCode==='0301'){
        policyNo = item.policyNo || '';
        jqNo = item.policyNo || '';
      }
      if(item.productCode==='0312'){
        policyNo = item.policyNo || '';
        syNo = item.policyNo || '';
      }
      if(item.mergeProductCode==='0301'){
        mergePolicyNo = item.mergePolicyNo;
        jqNo = item.mergePolicyNo || '';
      }
      if(item.mergeProductCode==='0312'){
        mergePolicyNo = item.mergePolicyNo || '';
        syNo = item.mergePolicyNo || '';
      }
      let str = `policyNo=${policyNo}&frameNo=${item.frameNo}&insuredName=${item.insuredName}&phone=${item.phone}&identifyNumber=${item.identifyNumber}&licenseNo=${item.licenseNo}&startDate=${item.startDate}&mergeStartDate=${item.mergeStartDate}&mergePolicyNo=${mergePolicyNo}&jqNo=${jqNo}&syNo=${syNo}&from=newcar&productCode=${item.productCode}&mergeProductCode=${item.mergeProductCode}`;
      location.href = process.env.VUE_APP_NOCAR_URL+`eb-web/wonhero/haclaim_app/index.html#/policyDetails1?${str}`;
    },
    getDaysBetween(dateString1,dateString2){//获取相差天数
      let nowdate = Date.parse(dateString1);
      let startDate = Date.parse(dateString2);
      let days=(nowdate - startDate)/(1*24*60*60*1000);
      return days;
    },
    hasCalc(item){
      let days = 0,
      jqDate = '',
      syDate = '';
      let nowDate = new Date().format('yyyy-MM-dd')
      // startDate
      // mergeStartDate
      // productCode
      if(item.productCode==='0301'){
        jqDate = item.startDate;
      }
      if(item.productCode==='0312'){
        syDate = item.startDate;
      }
      if(item.mergeProductCode==='0301'){
        jqDate = item.mergeStartDate;
      }
      if(item.mergeProductCode==='0312'){
        syDate = item.mergeStartDate;
      }
      if(jqDate && !syDate){
        //单交强
        days = this.getDaysBetween(nowDate,jqDate.split(' ')[0]);
      }else if(syDate && !jqDate){
         //单商业
        days = this.getDaysBetween(nowDate,syDate.split(' ')[0]);
      }else{
        
        let syDays = this.getDaysBetween(nowDate,syDate.split(' ')[0]);
        let jqDays = this.getDaysBetween(nowDate,jqDate.split(' ')[0]);
        if(syDays === jqDays){
            days = syDays;
        }else{
          if(syDays > 0 && jqDays <= 0){//交强已脱取交强
            days = jqDays;
          }else if(syDays <= 0 && jqDays > 0){//商业已脱取商业
            days = syDays;
          }else{//都已脱或者都未脱取最小
            days = jqDays > syDays ? syDays : jqDays;
          }
        }
      }
      if(days < 0){
        days = 0
      }else{
        days = days+1;
      }
      return days
    }

  }
    
}
